'use client';
import GreenButton from '@/components/GreenButton';
import ImageWithSkeleton from '@/components/hackathon/skeletons/ImageWithSkeleton';
import { EventCardProps } from '@/types';

const EventCard = (props: EventCardProps) => {
  return props.show ? (
    <div className="m-3 flex min-h-[300px] w-[340px] sm:w-[350px] flex-col items-center justify-evenly rounded-lg border-2 border-purple-br bg-purple-md py-3">
      <h2 className="font-raccoons text-3xl md:text-4xl text-center">{props.cardTitle}</h2>
      {props.cardImage ? (
        <div className="w-[300px] h-[200px]" data-testid="image-parent-div">
          <ImageWithSkeleton
            priority={true}
            imageStyles="object-cover w-[300px] h-[200px]"
            green={false}
            src={props.cardImage}
            width={300}
            height={200}
            alt="Image from event"
          />
        </div>
      ) : null}
      <GreenButton
        buttonStyles="rounded-lg z-20"
        buttonHref={props.buttonLink}
        buttonText={props.buttonText}
      />
    </div>
  ) : null;
};

export default EventCard;
